export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Pastas Advocatícias',
		path: '/',
		icon: 'Folder',
		color: 'grey',
		subMenu: null,
	},
	dashboardPastas: {
		id: 'dashboard-pastas',
		text: 'Dashboard Pastas',
		path: '/dashboard-pastas',
		icon: 'PieChart',
		color: 'info',
		subMenu: null,
	},
	config: {
		id: 'config',
		text: 'Configuração',
		path: '/config',
		icon: 'Settings',
		color: 'secondary',
		subMenu: {
			usuarios: {
				id: 'usuarios',
				text: 'Usuários e permissões',
				path: '/config/usuarios',
				icon: 'Person',
			},
			competenciaInterna: {
				id: 'competencia-interna',
				text: 'Competência interna',
				path: '/config/competencia-interna',
				icon: 'Assignment',
			},
			faseProcesso: {
				id: 'fase-processo',
				text: 'Fase processo',
				path: '/config/fase-processo',
				icon: 'Timeline',
			},
			varas: {
				id: 'varas',
				text: 'Vara cível',
				path: '/config/varas',
				icon: 'Gavel',
			},
		},
	},
};

export const appPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Pastas Advocatícias',
		path: '/',
		icon: 'Folder',
		color: 'grey',
		subMenu: null,
	},
	leads: {
		id: 'leads',
		text: 'Leads',
		path: 'leads',
		icon: 'Storefront',
		color: 'info',
		subMenu: null,
	},
	customers: {
		id: 'customers',
		text: 'Customers',
		path: 'customers',
		icon: 'People Alt',
		color: 'success',
		subMenu: null,
	},
	billing: {
		id: 'billing',
		text: 'Billing',
		path: 'billing',
		icon: 'Payments',
		color: 'danger',
		subMenu: null,
	},
};

export const profilePage = {
	profile: {
		id: 'profile',
		text: 'Profile',
		path: 'profile',
		icon: 'User',
		subMenu: null,
	},
};
